import React, { Component } from "react";
import { Table, Button, Modal, Row, Col, Tooltip, message, Icon, Select, Card } from "antd";
import axios from "axios";
import "./Pages.css";
import MonitorProducaoForm from '../components/MonitorProducaoForm';
import MonitorProducaoPrintModal from "../relatorios/MonitorProducaoPrintModal";
import FiltrosForm from '../components/FiltrosForm';
import JustificativaForm from '../components/JustificativaForm';
import moment from "moment-timezone";
import numeral from "numeral";
import { getUsuario, getTemPermissao, getTipoUsuario, getEmpresa } from "../utils/LoginManager";
import InputForm from "../components/InputForm";
import Colors from '../utils/Colors';

const dateFormat = 'DD/MM/YYYY'
const { Column } = Table;
const ButtonGroup = Button.Group;
const { Option } = Select;


export default class extends Component {

  constructor(props) {
    super(props);
    this.state = {
      listaRegistros: [],
      listaLinhasProducao: [],
      listaGrupo1: [], listaGrupo2: [], listaGrupo3: [], listaGrupo4: [], listaGrupo5: [], listaGrupo6: [], listaGrupo7: [], listaGrupo8: [],
      registro: '',
      eventStatus: '',
      carregando: false,
      pagina: 1,
      limite: 10,
      total: 0,

      qtdeTotal: 0,
      qtdePend: 0,
      qtdeFin: 0,

      modoListagem: 'G',

      formFiltroVisivel: false,
      formJustfVisivel: false,
      justificativa: '',

      selectedRowKeys: [],

      filtros: {
        tipoTela: 'MP',
        buscaOrdem: { campo: '', ordem: 'ASC' },
        // buscaDataIni: '01/01/2024',
        buscaDataIni: moment(new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1)).format('DD/MM/YYYY'),
        buscaDataFim: moment(new Date(new Date().getFullYear(), new Date().getMonth() + 2, 0)).format('DD/MM/YYYY'),
        buscaMes: 0,
        buscaAno: 0,
        buscaPessoa: { key: '0', },
        buscaUsuario: { key: '0', },
        buscaMunicipio: { key: '0', },
        buscaAgruparCidades: 0,
        buscaGrupoProduto: { key: '0' },
        buscaProduto: { key: '0' },
        buscaTipo: { key: 'X' },
        buscaControle: '',
        buscaAtividade: { key: '0', },
        buscaTipoAtiv: { key: 'X' },
        buscaLinhaProducao: { key: '0' },
        buscaPrioridade: 0,
        buscaStatusProducao: { key: '9999' },
      }

    };

  };



  componentDidMount() {
    this.loop();
    const usuario = getUsuario();
    getEmpresa().then(codEmpresa => {
      getTipoUsuario().then(tipoUsuario => {
        this.state.filtros.buscaLinhaProducao = {
          key: usuario.ue_linha_producao ? String(usuario.ue_linha_producao) : 0
        }
        this.setState({
          usuario,
          codEmpresa,
          tipoUsuario,
        }, this.getListaRegistros);
      })
    })
  }

  componentDidUpdate(antProps, antState) {
    const { total, pagina, limite } = this.state;
    const ultimaPagina = Math.ceil(total / limite);
    if (pagina > 1 && pagina > ultimaPagina) {
      this.setState({
        pagina: ultimaPagina
      }, this.getListaRegistros)
    }
  }


  loop = (value) => {
    setTimeout(() => {
      this.getListaRegistros();
      this.loop();
    }, 60000);
  }

  getListaRegistros = () => {
    this.setState({
      carregando: true, qtdeTotal: 0, qtdePend: 0, qtdeFin: 0,
      listaGrupo1: [], listaGrupo2: [], listaGrupo3: [], listaGrupo4: [], listaGrupo5: [], listaGrupo6: [], listaGrupo7: [], listaGrupo8: [],
    });
    const { pagina, limite } = this.state;

    const { buscaDataIni, buscaDataFim, buscaControle, buscaPessoa, buscaMunicipio,
      buscaProduto, buscaLinhaProducao, buscaPrioridade, buscaOrdem, buscaStatusProducao } = this.state.filtros;

    let op_dt_venda_ini = '';
    if ((buscaDataIni) && (buscaDataIni !== undefined)) {
      op_dt_venda_ini = moment(buscaDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }
    let op_dt_venda_fim = '';
    if ((buscaDataFim) && (buscaDataFim !== undefined)) {
      op_dt_venda_fim = moment(buscaDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }

    axios
      .get('/producao/monitorProducao', {
        params: {
          page: pagina,
          limite: limite,
          campoOrdem: buscaOrdem.campo,
          tipoOrdem: buscaOrdem.ordem,
          numero: buscaControle,
          codCliente: buscaPessoa.key,
          cidade: buscaMunicipio.key,
          produto: buscaProduto.key,
          linhaProducao: buscaLinhaProducao.key,
          prioridade: buscaPrioridade,
          statusProducao: buscaStatusProducao.key,
          op_dt_venda_ini,
          op_dt_venda_fim,
          print: 0,
        }
      })
      .then(response => {
        // console.log('getListaRegistros: Lista: ', response.data)

        let listaRegistros = response.data;
        let registroIndex;
        let listaLinhasProducao = [];
        for (var y in listaRegistros) {
          const idfLinhaProd = listaRegistros[y].lp_idf ? listaRegistros[y].lp_idf : 999999;
          const ordemLinhaProd = listaRegistros[y].lp_ordem ? listaRegistros[y].lp_ordem : 999999;
          const descrLinhaProd = listaRegistros[y].lp_descricao ? listaRegistros[y].lp_descricao : 'OUTROS';
          registroIndex = listaLinhasProducao.findIndex(tar => String(tar.lp_idf) === String(idfLinhaProd))
          if (parseInt(registroIndex) < 0) {
            listaLinhasProducao.push({
              lp_idf: idfLinhaProd,
              lp_descricao: descrLinhaProd,
              lp_ordem: ordemLinhaProd,
            })
          }
        }
        listaLinhasProducao.sort((a, b) => a.lp_ordem - b.lp_ordem);

        // console.log('getListaRegistros-FINAL', listaLinhasProducao)

        this.setState({
          listaRegistros,
          listaLinhasProducao,
          carregando: false,
          qtdeTotal: response.data.qtdeTotal,
          qtdePend: response.data.qtdePend,
          qtdeFin: response.data.qtdeFin,
        });
      })
      .catch(erro => {
        console.warn(erro);
        this.setState({
          carregando: false,
        });
      });
  };





  onSalvarClick = (registro) => {
    this.setState({
      salvando: true
    })

    // console.log('Registro gravar: ', registro);

    let request;
    if (registro.op_idf) {
      request = axios.put(`/producao/update/${registro.op_idf}`, registro);
    } else {
      request = axios.post(`/producao/store`, registro)
    }

    request
      .then(response => {
        this.getListaRegistros();
        this.setState({
          formVisivel: false,
          salvando: false,
        })
        message.success('Produção gravada com sucesso.');
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          salvando: false
        })
        Modal.error({ title: 'Erro Inesperado', content: 'Não foi possível salvar. ' + error.response.data, okText: 'OK', })
      })
  }


  onCancelarClick = () => {
    this.setState({
      formVisivel: false
    },
      this.getListaRegistros()
    )
  }

  onEditarClick = registro => {
    this.setState({ carregando: true });
    axios.get(`/producao/show/${registro.op_idf}`)
      .then(response => {
        const { data } = response;

        data.dados.op_pessoa = {
          key: String(data.dados.op_pessoa),
          label: data.dados.pes_nome,
        }
        data.dados.op_dt_emissao = moment(data.dados.op_dt_emissao, 'YYYY-MM-DD').format('DD/MM/YYYY');

        this.setState({
          formVisivel: true,
          registroSelecionado: data,
          carregando: false,
        })
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        })
      })
  };



  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    this.setState({
      [id]: value
    });
  };

  onBuscar = event => {
    event.preventDefault();
    this.getListaRegistros();
  }








  renderStatus = (sit, registro) => {
    if (sit) {
      return (
        <span style={{ fontSize: 11 }}>
          <Tooltip title="Alterar status da produção">
            <a style={{ color: "rgba(0, 0, 0, 0.45)", textDecorationLine: 'underline', fontWeight: 'bold' }}
              onClick={() => this.setState({
                formVisivel: true,
                registroSelecionado: {
                  op_idf: registro.op_idf,
                  pi_item: registro.pi_item,
                  pi_seq: registro.pi_seq,
                  pi_dt_producao: '',
                  editar: true,
                  pis_status: {
                    key: registro.idfStatus,
                    label: registro.descrStatus
                  },
                  tipo: 'ST',
                },
              })}>
              {sit}
            </a>
          </Tooltip>
        </span>
      )
    } else {
      <span></span>
    }

    // const op_situacao = {
    //   key: sit,
    //   label: registro.descrStatus,
    // }
    // return (
    //   <div style={{ marginTop: 0, marginBottom: -25 }}>
    //     <InputForm
    //       type="select"
    //       id="op_situacao"
    //       ref="op_situacao"
    //       value={op_situacao}
    //       placeholder="Status da Venda"
    //       onChange={situacao => this.onVerificaStatus(registro, situacao)}
    //       data={this.state.statusSelect}
    //       validator={value => Boolean(value)}
    //       style={{ width: 120 }}
    //       size="small"
    //     />
    //   </div>
    // );
  };

  onVerificaStatus = (registro, event) => {
    // console.log('onVerificaStatus: ', event)
    // if ((event.target.value.label === 'REVISAR') || (event.target.value.label === 'BLOQUEADA')) {
    //   this.onAbrirJustifClick(registro, event);
    // } else {
    //   this.onChangeStatus(registro, event, '')
    // }
    this.onChangeStatus(registro, event, '')
  }

  onChangeStatus = (registro, event, justificativa) => {
    justificativa = justificativa ? justificativa : 'X';

    // console.log('onChangeStatus: ', registro)
    // console.log('onChangeStatus: ', event)
    // console.log('onChangeStatus: ', justificativa)

    const reg = {
      pis_item: registro.pi_item,
      pis_seq: registro.pi_seq,
      pis_status: event.target.value.key,
      pis_obs: justificativa
    }

    this.setState({ carregando: true })
    axios.
      put(`/producao/updateStatus/${registro.op_idf}`, reg)
      .then(response => {
        registro.op_situacao = event.target.value.key;
        // registro.vj_data = moment().format('DD/MM/YYYY');
        // registro.vj_justf_bloq = event.target.value.key;
        this.setState({
          listaRegistros: this.state.listaRegistros.concat([]),
          // justificativa: '',
          registro: '',
          eventStatus: '',
          carregando: false
        }, () => {
          this.getListaRegistros();
        })
      }).catch(error => {
        console.error(error.response);
        this.setState({ carregando: false })
      })
  };

  buscaStatus = (value) => {
    this.setState({ statusSelect: [] })
    axios.get('/statusProducao/lista')
      .then(response => {
        const { data } = response;
        const statusSelect = data.map(regList => {
          return {
            key: regList.sp_idf,
            label: regList.sp_abrev,
          }
        });
        this.setState({
          statusSelect,
        })
      }).catch(error => {
        console.error(error.response);
      })
  }

  onAbrirJustifClick = (registro, eventStatus) => {
    this.setState({
      formJustfVisivel: true,
      registro,
      eventStatus,
      justificativa: '',
    })
  };

  onJustifClick = (justificativa) => {
    this.setState({
      formJustfVisivel: false,
      justificativa,
    }, this.onChangeStatus(this.state.registro, this.state.eventStatus, justificativa.justificativa))
  };

  onCancelarJustifClick = () => {
    this.setState({
      formJustfVisivel: false,
      justificativa: '',
      registro: '',
      eventStatus: '',
    })
  };







  renderAcoes = (text, registro) => {
    return (
      <ButtonGroup size="small">
        {getTemPermissao('MonitorProducaoPage', 'editar') ? (
          <Tooltip title={registro.op_dt_entrega ? "Visualizar" : "Editar"}>
            <Button className="botoesModalFormEditar" size="small" onClick={() => this.onEditarClick(registro, false)} icon={registro.op_dt_entrega ? "eye" : "edit"} />
          </Tooltip>
        ) : (
          <Tooltip title="Visualizar">
            <Button className="botoesModalFormEditar" size="small" onClick={() => this.onEditarClick(registro, false)} icon="eye" />
          </Tooltip>
        )}
      </ButtonGroup>
    );
  };




  onAbrirFiltroClick = () => {
    this.setState({
      formFiltroVisivel: true,
      filtros: {
        tipoTela: this.state.filtros.tipoTela,
        buscaOrdem: this.state.filtros.buscaOrdem,
        buscaDataIni: this.state.filtros.buscaDataIni,
        buscaDataFim: this.state.filtros.buscaDataFim,
        buscaMes: this.state.filtros.buscaMes,
        buscaAno: this.state.filtros.buscaAno,
        buscaPessoa: this.state.filtros.buscaPessoa,
        buscaUsuario: this.state.filtros.buscaUsuario,
        buscaMunicipio: this.state.filtros.buscaMunicipio,
        buscaAgruparCidades: this.state.filtros.buscaAgruparCidades,
        buscaGrupoProduto: this.state.filtros.buscaGrupoProduto,
        buscaProduto: this.state.filtros.buscaProduto,
        buscaTipo: this.state.filtros.buscaTipo,
        buscaControle: this.state.filtros.buscaControle,
        buscaAtividade: this.state.filtros.buscaAtividade,
        buscaTipoAtiv: this.state.filtros.buscaTipoAtiv,
        buscaLinhaProducao: this.state.filtros.buscaLinhaProducao,
        buscaPrioridade: this.state.filtros.buscaPrioridade,
        buscaStatusProducao: this.state.filtros.buscaStatusProducao,
      }
    })
  };

  onFiltrarClick = (filtros) => {
    this.setState({
      formFiltroVisivel: false,
      filtros,
    },
      this.getListaRegistros(filtros)
    )
  };

  onCancelarFiltroClick = () => {
    this.setState({
      formFiltroVisivel: false,
    })
  };





  renderValor = (valor) => {
    return (
      <span> {numeral(parseFloat(valor)).format('0,000.00')} </span>
    );
  };

  renderDataHora = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span>
          {dataMoment.format('DD/MM/YYYY HH:mm')}
        </span>
      )
    } else {
      <span></span>
    }
  }

  renderDataProducao = (data, registro) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span style={{ fontSize: 11 }}>
          {getTemPermissao('MonitorProducaoAdmPage', 'cons') ? (
            <Tooltip title="Alterar data de produção">
              <a style={{ color: "rgba(0, 0, 0, 0.45)", textDecorationLine: 'underline', fontWeight: 'bold' }}
                onClick={() => this.setState({
                  formVisivel: true,
                  registroSelecionado: {
                    op_idf: registro.op_idf,
                    pi_item: registro.pi_item,
                    pi_seq: registro.pi_seq,
                    pi_dt_producao: moment(registro.pi_dt_producao, 'YYYY-MM-DD').format('DD/MM/YYYY'),
                    pis_status: { key: 0, label: '' },
                    editar: true,
                    tipo: 'DP',
                  },
                })}>
                {dataMoment.format('DD/MM/YYYY')}
              </a>
            </Tooltip>
          ) : (
            <span>{dataMoment.format('DD/MM/YYYY')}</span>
          )}
        </span>
      )
    } else {
      <span>---</span>
    }
  }

  renderDiaMesProducao = (data, registro) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span style={{ fontSize: 11 }}>
          {getTemPermissao('MonitorProducaoAdmPage', 'cons') ? (
            <Tooltip title="Alterar data de produção">
              <a style={{ color: "rgba(0, 0, 0, 0.45)", textDecorationLine: 'underline', fontWeight: 'bold' }}
                onClick={() => this.setState({
                  formVisivel: true,
                  registroSelecionado: {
                    op_idf: registro.op_idf,
                    pi_item: registro.pi_item,
                    pi_seq: registro.pi_seq,
                    pi_dt_producao: moment(registro.pi_dt_producao, 'YYYY-MM-DD').format('DD/MM/YYYY'),
                    pis_status: { key: 0, label: '' },
                    editar: true,
                    tipo: 'DP',
                  },
                })}>
                {dataMoment.format('DD/MM')}
              </a>
            </Tooltip>
          ) : (
            <span>{dataMoment.format('DD/MM')}</span>
          )}

        </span>
      )
    } else {
      <span>---</span>
    }
  }

  renderDataEntrega = (data, registro) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span style={{ fontSize: 11 }}>
          {getTemPermissao('MonitorProducaoAdmPage', 'cons') ? (
            <Tooltip title="Alterar data de entrega">
              <a style={{ color: "rgba(0, 0, 0, 0.45)", textDecorationLine: 'underline', fontWeight: 'bold' }}
                onClick={() => this.setState({
                  formVisivel: true,
                  registroSelecionado: {
                    op_idf: registro.op_idf,
                    pi_item: registro.pi_item,
                    pi_seq: registro.pi_seq,
                    pi_dt_entrega: moment(registro.pi_dt_entrega, 'YYYY-MM-DD').format('DD/MM/YYYY'),
                    pis_status: { key: 0, label: '' },
                    editar: true,
                    tipo: 'DE',
                  },
                })}>
                {dataMoment.format('DD/MM/YYYY')}
              </a>
            </Tooltip>
          ) : (
            <span>{dataMoment.format('DD/MM/YYYY')}</span>
          )}
        </span>
      )
    } else {
      return (
        <span style={{ fontSize: 11 }}>
          {getTemPermissao('MonitorProducaoAdmPage', 'cons') ? (
            <Tooltip title="Alterar data de entrega">
              <a style={{ color: "rgba(0, 0, 0, 0.45)", fontWeight: 'bold' }}
                onClick={() => this.setState({
                  formVisivel: true,
                  registroSelecionado: {
                    op_idf: registro.op_idf,
                    pi_item: registro.pi_item,
                    pi_seq: registro.pi_seq,
                    pi_dt_entrega: moment().format('DD/MM/YYYY'),
                    pis_status: { key: 0, label: '' },
                    editar: true,
                    tipo: 'DE',
                  },
                })}>
                ---
              </a>
            </Tooltip>
          ) : (
            <span>---</span>
          )}
        </span>
      )
    }
  }

  renderDiaMesEntrega = (data, registro) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span style={{ fontSize: 11 }}>
          {getTemPermissao('MonitorProducaoAdmPage', 'cons') ? (
            <Tooltip title="Alterar data de entrega">
              <a style={{ color: "rgba(0, 0, 0, 0.45)", textDecorationLine: 'underline', fontWeight: 'bold' }}
                onClick={() => this.setState({
                  formVisivel: true,
                  registroSelecionado: {
                    op_idf: registro.op_idf,
                    pi_item: registro.pi_item,
                    pi_seq: registro.pi_seq,
                    pi_dt_entrega: moment(registro.pi_dt_entrega, 'YYYY-MM-DD').format('DD/MM/YYYY'),
                    pis_status: { key: 0, label: '' },
                    editar: true,
                    tipo: 'DE',
                  },
                })}>
                {dataMoment.format('DD/MM')}
              </a>
            </Tooltip>
          ) : (
            <span>{dataMoment.format('DD/MM')}</span>
          )}
        </span>
      )
    } else {
      return (
        <span style={{ fontSize: 11 }}>
          {getTemPermissao('MonitorProducaoAdmPage', 'cons') ? (
            <Tooltip title="Alterar data de entrega">
              <a style={{ color: "rgba(0, 0, 0, 0.45)", fontWeight: 'bold' }}
                onClick={() => this.setState({
                  formVisivel: true,
                  registroSelecionado: {
                    op_idf: registro.op_idf,
                    pi_item: registro.pi_item,
                    pi_seq: registro.pi_seq,
                    pi_dt_entrega: moment().format('DD/MM/YYYY'),
                    pis_status: { key: 0, label: '' },
                    editar: true,
                    tipo: 'DE',
                  },
                })}>
                ---
              </a>
            </Tooltip>
          ) : (
            <span>---</span>
          )}
        </span>
      )
    }
  }

  renderCliente = (usu_nome, registro) => {
    return (
      <Tooltip title={"O.P Nº " + registro.op_numero + (registro.ven_numero ? " - Pedido Nº " + registro.ven_numero : "") + ' - ' + registro.pes_nome} >
        <span style={{ fontSize: 11 }}>{usu_nome.substring(0, 15)}</span>
      </Tooltip>
    );
  };

  renderProduto = (prod_descricao, registro) => {
    return (
      <Tooltip title={registro.prod_codigo + ' - ' + registro.prod_descricao} >
        <span style={{ fontSize: 11 }}>{prod_descricao}</span>
      </Tooltip>
    );
  };

  renderCidade = (cmun_descricao, registro) => {
    return (
      <span>{cmun_descricao} - {registro.cuf_sigla}</span>
    );
  };

  renderProduto1 = (prod_descricao, registro) => {
    return (
      <span>{'[' + registro.prod_codigo + '] ' + prod_descricao}</span>
    );
  };

  renderBotaoOBS = (text, registro) => {
    return (
      <ButtonGroup size="small">
        {getTemPermissao('MonitorProducaoAdmPage', 'cons') ? (
          <Tooltip title={"Observação"}>
            <Button type="ghost" size="small" icon="info-circle-o" style={{ background: registro.pi_obs ? "#f9fa78" : "" }}
              onClick={() => this.setState({
                formVisivel: true,
                registroSelecionado: {
                  op_idf: registro.op_idf,
                  pi_item: registro.pi_item,
                  pi_seq: registro.pi_seq,
                  pi_obs: registro.pi_obs,
                  pis_status: { key: 0, label: '' },
                  tipo: 'OBS',
                  editar: true,
                },
              })}
            />
          </Tooltip>
        ) : (
          <Tooltip title="Observação">
            <Button type="ghost" size="small" icon="info-circle-o" style={{ background: registro.pi_obs ? "#f9fa78" : "" }}
              onClick={() => this.setState({
                formVisivel: true,
                registroSelecionado: {
                  op_idf: registro.op_idf,
                  pi_item: registro.pi_item,
                  pi_seq: registro.pi_seq,
                  pi_obs: registro.pi_obs,
                  pis_status: { key: 0, label: '' },
                  tipo: 'OBS',
                  editar: false,
                },
              })}
            />
          </Tooltip>
        )}
      </ButtonGroup>
    );
  };




  onOrdenarListaClick = (column) => {
    const { filtros } = this.state;
    const ordem = filtros.buscaOrdem.campo && filtros.buscaOrdem.campo === column.dataIndex ? (filtros.buscaOrdem.ordem && filtros.buscaOrdem.ordem === 'ASC' ? 'DESC' : 'ASC') : 'ASC';
    filtros['buscaOrdem'] = { campo: column.dataIndex, ordem };
    this.setState({
      filtros,
      pagina: 1,
    }, this.getListaRegistros)
  };

  renderTitulo = (col) => {
    return (
      <Tooltip title="Clique para Ordenar"><div style={{ background: "#ececec", cursor: 'pointer', padding: 2, marginLeft: -5, marginRight: -5 }}>{col}</div></Tooltip>
    );
  };


  onTabelaChange = (pagination => {
    this.setState({
      pagina: pagination.current,
      limite: pagination.pageSize,
    },
      this.getListaRegistros)
  })

  onSelectChange = selectedRowKeys => {
    // console.log('selectedRowKeys changed: ', selectedRowKeys);
    this.setState({ selectedRowKeys });
  };



  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------




  render() {
    const { listaRegistros, listaLinhasProducao,
      carregando, formVisivel, salvando, registroSelecionado, filtros, justificativa,
      modoListagem, formFiltroVisivel, formJustfVisivel, selectedRowKeys } = this.state;

    let { listaGrupo1, listaGrupo2, listaGrupo3, listaGrupo4, listaGrupo5, listaGrupo6, listaGrupo7, listaGrupo8 } = this.state;

    // console.log('MonitorProducaoPage.this.state: ', this.state);

    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
    };
    const hasSelected = selectedRowKeys.length > 0;

    return (
      <div className="contentRoutesContainer">

        <div className="pageFiltro" style={{ height: 65, marginTop: -15 }}>
          <Row>
            <Col xs={12} style={{ marginTop: 15 }}>
              <h2 className="tituloPage" style={{ marginBottom: -10, marginTop: -20 }}>Monitor de Produção</h2>
            </Col>
            <Col xs={12} style={{ textAlign: 'right' }}>

              <Tooltip title="Atualizar Lista">
                <Button type="dashed" size="default" onClick={() => this.getListaRegistros()} icon={"reload"} />
              </Tooltip>

              <Tooltip title="Alterar modo de listagem">
                <Button type="dashed" size="default" style={{ marginLeft: 15 }} onClick={() => this.setState({ modoListagem: modoListagem === 'C' ? 'L' : modoListagem === 'L' ? 'G' : 'C' })} icon={modoListagem === 'L' ? "bars" : modoListagem === 'C' ? "appstore-o" : "layout"} />
              </Tooltip>

              <Button
                onClick={this.onAbrirFiltroClick}
                className="pageFiltro-filtrar"
                style={{ marginLeft: 15 }}
              >
                Filtrar
              </Button>

              <FiltrosForm
                visivel={formFiltroVisivel}
                onFiltrarClick={this.onFiltrarClick}
                onCancelarFiltroClick={this.onCancelarFiltroClick}
                filtros={filtros}
              />

              <MonitorProducaoPrintModal
                listaRegistros={listaRegistros}
              />

              <JustificativaForm
                visivel={formJustfVisivel}
                onJustifClick={this.onJustifClick}
                onCancelarJustifClick={this.onCancelarJustifClick}
                justificativa={justificativa}
              />

              <MonitorProducaoForm
                visivel={formVisivel}
                onSalvarClick={this.onSalvarClick}
                onCancelarClick={this.onCancelarClick}
                carregando={salvando}
                registroSelecionado={registroSelecionado}
              />
            </Col>

          </Row>

        </div>


        <div style={{ marginTop: -30 }}>

          {modoListagem === 'G' ? (

            <Card style={{ backgroundColor: "#f3f6f6", margin: -15 }} >

              {listaLinhasProducao.map((regList, index) => {

                let listaAux = [];
                for (var y in listaRegistros) {
                  if ((parseInt(regList.lp_idf) === 999999) && (!parseInt(listaRegistros[y].lp_idf))) {
                    listaAux.push(listaRegistros[y]);
                  } else if (parseInt(regList.lp_idf) === parseInt(listaRegistros[y].lp_idf)) {
                    listaAux.push(listaRegistros[y]);
                  }
                }

                if (index === 0) {
                  listaGrupo1 = listaAux;
                } else if (index === 1) {
                  listaGrupo2 = listaAux;
                } else if (index === 2) {
                  listaGrupo3 = listaAux;
                } else if (index === 3) {
                  listaGrupo4 = listaAux;
                } else if (index === 4) {
                  listaGrupo5 = listaAux;
                } else if (index === 5) {
                  listaGrupo6 = listaAux;
                } else if (index === 6) {
                  listaGrupo7 = listaAux;
                } else if (index === 7) {
                  listaGrupo8 = listaAux;
                }
                <span style={{ marginTop: 8, fontSize: 15, fontWeight: 'bold' }}>
                  {hasSelected ? `Selecionados ${selectedRowKeys.length} items` : ''}
                </span>

                return (
                  <Card.Grid
                    style={{
                      width: this.state.filtros.buscaLinhaProducao && this.state.filtros.buscaLinhaProducao.key && this.state.filtros.buscaLinhaProducao.key !== '0' ? '100%' : '50%',
                      height: this.state.filtros.buscaLinhaProducao && this.state.filtros.buscaLinhaProducao.key && this.state.filtros.buscaLinhaProducao.key !== '0' ? '100%' : 500,
                      textAlign: 'left',
                      backgroundColor: "white",
                      marginBottom: 5,
                      padding: 0,
                      paddingLeft: 15,
                      paddingRight: 15,
                      borderLeft: '5px solid',
                      borderColor: Colors.primaryLight,
                      borderRadius: 5,
                    }}
                  >
                    <span style={{ fontSize: 25, fontWeight: "bold", color: Colors.primaryLight }}>{regList.lp_descricao}</span>
                    {/* {regList.lp_idf !== 999999 ? ( */}
                    <Tooltip title="Alterar dados em grupo">
                      <Button type="default" size="default"
                        style={{ float: "right", marginRight: 10, marginTop: 20 }}
                        icon={"calendar"}
                        onClick={() => this.setState({
                          formVisivel: selectedRowKeys.length ? true : false,
                          registroSelecionado: {
                            op_idf: 0,
                            pi_item: 0,
                            pi_seq: 0,
                            lp_idf: regList.lp_idf,
                            pi_dt_producao: moment().format('DD/MM/YYYY'),
                            pi_dt_entrega: moment().format('DD/MM/YYYY'),
                            pis_status: { key: 0, label: '' },
                            editar: true,
                            tipo: 'GRUPO',
                            listaProducao: selectedRowKeys
                          },
                        })} />
                    </Tooltip>
                    {/* ) : null} */}

                    <Table
                      pagination={false}
                      onChange={this.onTabelaChange}
                      dataSource={index === 0 ? listaGrupo1 : index === 1 ? listaGrupo2 : index === 2 ? listaGrupo3 : index === 3 ? listaGrupo4 : index === 4 ? listaGrupo5 : index === 5 ? listaGrupo6 : index === 6 ? listaGrupo7 : listaGrupo8}
                      scroll={{ y: this.state.filtros.buscaLinhaProducao && this.state.filtros.buscaLinhaProducao.key && this.state.filtros.buscaLinhaProducao.key !== '0' ? '100%' : 400, }}
                      rowKey={(registro => registro.op_idf + '_' + registro.pi_item + '_' + registro.pi_seq)}
                      onRow={(record, index) => ({
                        style: {
                          background: record.corStatus === record.corStatus ? record.corStatus : 'white',
                        }
                      })}
                      rowSelection={rowSelection}
                      size="small"
                    >
                      <Column
                        key="pi_dt_producao"
                        dataIndex="pi_dt_producao"
                        title={this.renderTitulo("Produção")}
                        onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                        render={this.renderDiaMesProducao}
                        width={"12%"}
                        align="center"
                        className="listaCadastro"
                      />
                      <Column
                        key="prod_descricao"
                        dataIndex="prod_descricao"
                        title={this.renderTitulo("Produto")}
                        onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                        render={this.renderProduto}
                        width={"30%"}
                        align="left"
                        className="listaCadastro"
                      />
                      <Column
                        key="pes_nome"
                        dataIndex="pes_nome"
                        title={this.renderTitulo("Cliente")}
                        onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                        render={this.renderCliente}
                        width={"15%"}
                        align="left"
                        className="listaCadastro"
                      />
                      <Column
                        key="pi_qtde"
                        dataIndex="pi_qtde"
                        title={this.renderTitulo("Qtde")}
                        onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                        render={this.renderValor}
                        width={"11%"}
                        align="right"
                        className="listaCadastro"
                      />
                      <Column
                        key="descrStatus"
                        dataIndex="descrStatus"
                        title={this.renderTitulo("ST")}
                        onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                        render={this.renderStatus}
                        width={"10%"}
                        align="center"
                        className="listaCadastro"
                      />
                      <Column
                        key="op_prioridade"
                        dataIndex="op_prioridade"
                        title={this.renderTitulo("Prd")}
                        onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                        width={"5%"}
                        align="center"
                        className="listaCadastro"
                      />
                      <Column
                        key="pi_dt_entrega"
                        dataIndex="pi_dt_entrega"
                        title={this.renderTitulo("Expedição")}
                        onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                        render={this.renderDiaMesEntrega}
                        width={"12%"}
                        align="center"
                        className="listaCadastro"
                      />
                      <Column
                        key="."
                        dataIndex="."
                        title={this.renderTitulo(".")}
                        render={this.renderBotaoOBS}
                        width={"5%"}
                        align="center"
                        className="listaCadastro"
                      />
                    </Table>
                  </Card.Grid>
                );
              })}
            </Card>

          ) : modoListagem === 'C' ? (

            <Card style={{ backgroundColor: "#f3f6f6" }} >

              {listaRegistros.map(regList => {
                return (

                  <Card.Grid
                    style={{
                      width: '25%',
                      height: 300,
                      textAlign: 'left',
                      backgroundColor: "white",
                      marginBottom: 5,
                      padding: 0,
                      paddingLeft: 20,
                      paddingRight: 20,
                      borderLeft: '5px solid',
                      borderColor: Colors.primaryLight,
                      borderRadius: 5,
                    }}
                  >
                    <Row style={{ marginTop: -10, height: 50 }}>
                      <Col xs={16} style={{ height: 50 }}>
                        <Row>
                          <span style={{ fontSize: 13, fontWeight: "bold", color: Colors.primaryLight }}>Data Produção</span>
                        </Row>
                        <Row style={{ marginTop: -40 }}>
                          <span style={{ fontSize: 15, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>
                            {this.renderDataProducao(regList.pi_dt_producao, regList)}
                          </span>
                        </Row>
                      </Col>
                      <Col xs={8} style={{ textAlign: 'right', height: 50 }}>
                        <Row>
                          <span style={{ fontSize: 13, fontWeight: "bold", color: Colors.primaryLight }}>Qtde</span>
                        </Row>
                        <Row style={{ marginTop: -40 }}>
                          <span style={{ fontSize: 15, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>
                            {this.renderValor(regList.pi_qtde)}
                          </span>
                        </Row>
                      </Col>
                    </Row>

                    <Row style={{ marginTop: -40, height: 150 }}>
                      <Row>
                        <span style={{ fontSize: 13, fontWeight: "bold", color: Colors.primaryLight }}>Produto</span>
                        <span style={{ fontSize: 13, color: "rgba(0, 0, 0, 0.45)" }}> - {regList.prod_codigo}</span>
                      </Row>
                      <Row style={{ marginTop: -10 }}>
                        <p style={{ fontSize: 15, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>
                          {regList.prod_descricao}
                        </p>
                      </Row>
                    </Row>

                    <Row style={{ marginTop: -20, height: 100 }}>
                      <Row>
                        <span style={{ fontSize: 13, fontWeight: "bold", color: Colors.primaryLight }}>Cliente</span>
                      </Row>
                      <Row style={{ marginTop: -10 }}>
                        <p style={{ fontSize: 14, color: "rgba(0, 0, 0, 0.45)" }}>
                          {regList.pes_nome}
                        </p>
                        <p style={{ marginTop: -15, fontSize: 12, color: "rgba(0, 0, 0, 0.45)" }}>
                          {regList.cmun_descricao} - {regList.cuf_sigla}
                        </p>
                      </Row>
                    </Row>

                    <Row style={{ marginTop: -20 }}>
                      <Col xs={16} style={{ height: 50 }}>
                        <Row>
                          <span style={{ fontSize: 13, fontWeight: "bold", color: Colors.primaryLight }}>Status</span>
                        </Row>
                        <Row style={{ marginTop: -10 }}>
                          <p style={{ fontSize: 15, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>
                            {this.renderStatus(regList.descrStatus, regList)}
                          </p>
                        </Row>
                      </Col>
                      <Col xs={8} style={{ height: 50 }}>
                        <Row>
                          <span style={{ fontSize: 13, fontWeight: "bold", color: Colors.primaryLight }}>Prioridade</span>
                        </Row>
                        <Row style={{ marginTop: -10 }}>
                          <p style={{ fontSize: 15, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>
                            {regList.op_prioridade}
                          </p>
                        </Row>
                      </Col>
                    </Row>
                  </Card.Grid>

                );
              })}
            </Card>

          ) : (

            <Table
              pagination={false}
              onChange={this.onTabelaChange}
              loading={{
                spinning: carregando,
                tip: 'Carregando. Aguarde...',
                size: "large"
              }}
              dataSource={listaRegistros}
              rowKey={(registro => registro.op_idf + '_' + registro.pi_item)}
              onRow={(record, index) => ({
                style: {
                  background: record.corStatus === record.corStatus ? record.corStatus : 'white',
                }
              })}
            >
              <Column
                key="pi_dt_producao"
                dataIndex="pi_dt_producao"
                title={this.renderTitulo("Produção")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                render={this.renderDataProducao}
                width={"10%"}
                align="center"
                className="listaCadastro"
              />
              <Column
                key="lp_descricao"
                dataIndex="lp_descricao"
                title={this.renderTitulo("Linha Pordução")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                width={"10%"}
                align="left"
                className="listaCadastro"
              />
              <Column
                key="op_numero"
                dataIndex="op_numero"
                title={this.renderTitulo("Controle")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                width={"10%"}
                align="center"
                className="listaCadastro"
              />
              <Column
                key="ven_numero"
                dataIndex="ven_numero"
                title={this.renderTitulo("Pedido")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                width={"10%"}
                align="center"
                className="listaCadastro"
              />
              <Column
                key="prod_descricao"
                dataIndex="prod_descricao"
                title={this.renderTitulo("Produto")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                render={this.renderProduto1}
                width={"10%"}
                align="left"
                className="listaCadastro"
              />
              <Column
                key="op_prioridade"
                dataIndex="op_prioridade"
                title={this.renderTitulo("Prioridade")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                width={"10%"}
                align="center"
                className="listaCadastro"
              />
              <Column
                key="pi_qtde"
                dataIndex="pi_qtde"
                title={this.renderTitulo("Qtde")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                render={this.renderValor}
                width={"10%"}
                align="right"
                className="listaCadastro"
              />
              <Column
                key="pes_nome"
                dataIndex="pes_nome"
                title={this.renderTitulo("Cliente")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                render={this.renderCliente}
                width={"10%"}
                align="left"
                className="listaCadastro"
              />
              {/* <Column
                key="cmun_descricao"
                dataIndex="cmun_descricao"
                title={this.renderTitulo("Cidade")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                render={this.renderCidade}
                width={"10%"}
                align="left"
                className="listaCadastro"
              /> */}
              <Column
                key="descrStatus"
                dataIndex="descrStatus"
                title={this.renderTitulo("Status")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                render={this.renderStatus}
                width={"10%"}
                align="center"
                className="listaCadastro"
              />
              <Column
                key="pi_dt_entrega"
                dataIndex="pi_dt_entrega"
                title={this.renderTitulo("Entrega")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                render={this.renderDataEntrega}
                width={"10%"}
                align="center"
                className="listaCadastro"
              />
            </Table>

          )}

        </div>

      </div >
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/MonitorProducaoPage.js